import {
  CMS_CATE_DETAIL_FIELD_KEY
} from "./chunk-GXKHLBEY.js";
import {
  BaseItemModel_default
} from "./chunk-UPAELC5I.js";
import {
  BaseModel_default
} from "./chunk-ITJMNR7M.js";

// src/Cms/Categories/CMSCategoriesModel.ts
var CategoryModel = class extends BaseModel_default {
  constructor(entities) {
    super(entities);
    if (entities) {
      this.items = entities._embedded.item.map((element) => {
        return new CategoriesItemModel(element);
      });
    }
  }
};
var CategoriesItemModel = class extends BaseItemModel_default {
  constructor(entity) {
    super(entity);
    this.id = null;
    this.check = false;
    this.engagement = "";
    this.languages = "";
    this.title = "";
    this.status = "";
    this.type = "";
    this.visits = "";
    this.description = "";
    this.featured_image = "";
    this.toObject = () => {
      return {};
    };
    this.toJSON = () => {
      return {
        ...this.baseToJSON(),
        [CMS_CATE_DETAIL_FIELD_KEY.ID]: this.id,
        [CMS_CATE_DETAIL_FIELD_KEY.CHECK]: this.check,
        [CMS_CATE_DETAIL_FIELD_KEY.ENGAGEMENT]: this.engagement,
        [CMS_CATE_DETAIL_FIELD_KEY.LANGUAGES]: this.languages,
        [CMS_CATE_DETAIL_FIELD_KEY.TITLE]: this.title,
        [CMS_CATE_DETAIL_FIELD_KEY.STATUS]: this.status,
        [CMS_CATE_DETAIL_FIELD_KEY.TYPE]: this.type,
        [CMS_CATE_DETAIL_FIELD_KEY.VISITS]: this.visits,
        [CMS_CATE_DETAIL_FIELD_KEY.DESCRIPTION]: this.description,
        [CMS_CATE_DETAIL_FIELD_KEY.FEATURED_IMAGE]: this.featured_image
      };
    };
    if (entity) {
      this.id = entity[CMS_CATE_DETAIL_FIELD_KEY.ID] ?? "";
      this.check = entity[CMS_CATE_DETAIL_FIELD_KEY.CHECK] ?? "";
      this.engagement = entity[CMS_CATE_DETAIL_FIELD_KEY.ENGAGEMENT] ?? "";
      this.languages = entity[CMS_CATE_DETAIL_FIELD_KEY.LANGUAGES] ?? "";
      this.title = entity[CMS_CATE_DETAIL_FIELD_KEY.TITLE] ?? "";
      this.status = entity[CMS_CATE_DETAIL_FIELD_KEY.STATUS] ?? "";
      this.type = entity[CMS_CATE_DETAIL_FIELD_KEY.TYPE] ?? "";
      this.visits = entity[CMS_CATE_DETAIL_FIELD_KEY.VISITS] ?? "";
      this.description = entity[CMS_CATE_DETAIL_FIELD_KEY.DESCRIPTION] ?? "";
      this.featured_image = entity[CMS_CATE_DETAIL_FIELD_KEY.FEATURED_IMAGE]?.url ?? "";
    }
  }
};
CategoriesItemModel.__transformItemToApiOfCreation = (data) => {
  let formData = new FormData();
  formData.append(CMS_CATE_DETAIL_FIELD_KEY.ID, data[CMS_CATE_DETAIL_FIELD_KEY.ID] ?? 0);
  return formData;
};

export {
  CategoryModel,
  CategoriesItemModel
};
